<template>
  <div>
    <data-list :payload="orderObj" :headers="headers" v-model="pagination" :total="total" :pagination="pagination">
      <v-container slot="filterForm">
        <v-row>
          <v-col cols="12" lg="3">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn color="primary"  dark v-on="on">{{$t('message.common.addNew')}}</v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in menuItems" :key="index" :to="item.to">
                  <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
          <v-col cols="6" lg="3">
            <v-select v-model="filterObj.type" dense outlined clearable :items="$_orderType" item-text="text" item-value="value" :label="$t('message.whOrder.orderType')" hide-details></v-select>
          </v-col>
          <v-col cols="6" lg="2">
            <v-select v-model="filterObj.status" dense outlined clearable :items="statusList" item-text="text" item-value="value" :label="$t('message.customer.status')" hide-details></v-select>
          </v-col>
          <v-col cols="6" lg="3">
            <v-text-field single-line outlined dense v-model="filterObj.search" :label="$t('message.common.search')" class="text-xs-right" id="searchbtn"  hide-details></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </data-list>
    <div id="noso_products" style="visibility: hidden;"></div>
  </div>
</template>
<script>
/* eslint-disable */
import DataList from '@/components/DataList'
import { mapState } from 'vuex'
import CONSTANTS from '@/utils/warehouse.json'
export default {
  components: {
    DataList
  },
  data () {
    return {
      filterObj: {
        'descending': true,
        'totalitems': 0,
        'search': '',
        'status': null,
        'type': null
      },
      filterBy: 'supplier',
      orderObj: {
        isHeader: true,
        isHideAdd: true,
        hasFilters: true,
        selection: [],
        showSelect: false,
        isStock: true,
        list: [],
        page: 1,
        loading: false,
        editProp: 'number',
        editURL: (item) => this.navigateToOrder(item),
        actionsList: [{
          click: this.$parent.$parent.printOrder,
          icon: () => 'mdi-arrow-down-bold-circle-outline',
          is_show: () => true
        }, {
          click: this.$parent.$parent.sendReport,
          icon: () => 'mdi-email-variant',
          is_show: () => true
        }, {
          click: this.$parent.$parent.donwloadPrintedProducts,
          icon: () => 'mdi-printer',
          is_show: (item) => item.type_ref === CONSTANTS.SUPPLIER
        }, {
          click: this.deleteOrder,
          icon: () => 'mdi-trash-can-outline',
          is_show: (item) => item.status_ref === CONSTANTS.DRAFT
        }]
      },
      total: 0,
      page: 1,
      loading: false,
      MODULE_URL: 'warehouseorders',
      orderModel: {},
      isValidEmail: false,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.WH_ORDER_INDEX) ? this.$store.state.WH_ORDER_INDEX : { sortBy: ['number'], itemsPerPage: 25, sortDesc: [true], search: '', page: 1 }
    }
  },
  watch: {
    pagination: {
      handler (val) {
        let model = {
          type: 'WH_ORDER_INDEX',
          data: val
        }
        this.$store.commit('rememberOrder', model)
        this.getOrderListHandler()
      },
      deep: true
    },
    search: function (newValue, oldValue) {
      if (!newValue) this.getOrderListHandler()
    },
    filterObj: {
      handler (newValue, oldValue) {
        if (newValue) {
          let data = { type: 'F_WH_ORDERS', data: { filter: newValue } }
          this.$store.commit('rememberFilter', data)
          this.getOrderListHandler()
        }
      },
      deep: true
    }
  },
  computed: {
    statusList () {
      return [ { text: this.$t('message.common.draft'), value: 'draft' },
        { text: this.$t('message.common.request'), value: 'request' },
        { text: this.$t('message.common.inProgress'), value: 'inprogress' },
        { text: this.$t('message.common.ordered'), value: 'ordered' },
        { text: this.$t('message.common.picked'), value: 'picked' },
        { text: this.$t('message.common.partiallyPicked'), value: 'partiallypicked' },
        { text: this.$t('message.common.partiallyReceived'), value: 'partiallyreceived' },
        { text: this.$t('message.common.received'), value: 'received' } ]
    },
    menuItems () {
      return [{ title: 'message.whOrder.supplierOrder', to: '/w_h/order/supplierorder/actions' },
        { title: 'message.warehouse.lowStockProposal', to: '/w_h/order/lowstockproposal' },
        { title: 'message.whOrder.adjustmentOrder', to: '/w_h/order/adjustmentorder/actions' },
        { title: 'message.whOrder.returnOrder', to: '/w_h/order/returnorder/actions' },
        { title: 'message.whOrder.transferOrder', to: '/w_h/order/transferorder/actions' }]
    },
    ...mapState(['WH_ORDER_INDEX', 'listOfLocations', 'listOfWarehouse']),
    headers () {
      return [{
        text: this.$t('message.product.number'),
        value: 'number',
        width: '10%'
      }, {
        text: this.$t('message.whOrder.orderType'),
        value: 'type',
        width: '15%'
      }, {
        text: this.$t('message.whOrder.from'),
        value: 'supplier_name',
        width: '10%'
      }, {
        text: this.$t('message.whOrder.to'),
        value: 'warehouse_name',
        width: '10%'
      }, {
        text: this.$t('message.whOrder.orderDate'),
        value: 'orderdate',
        width: '10%'
      }, {
        text: this.$t('message.layout.priority'),
        value: 'priority',
        width: '10%'
      }, {
        text: this.$t('message.customer.status'),
        value: 'status',
        width: '10%'
      }, {
        text: this.$t('message.deviations.responsible'),
        value: 'responsible',
        width: '15%'
      }, {
        text: '',
        value: 'actions',
        width: '11%'
      }]
    }
  },
  created () {
    this.$store.dispatch('getWarehouse')
    this.$store.dispatch('getWarehouseLocations')
  },
  mounted () {
    let text = this.$t('message.common.deleteSuccess')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE_URL) {
        let payload = { ids: data.ids, url: `${this.MODULE_URL}/delete_multiple`, module: this.MODULE_URL }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE_URL) {
        this.orderObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getOrderListHandler()
      }
    })
    if (!this.$formatter.isEmptyObject(this.$store.state.F_WH_ORDERS)) {
      let order = this.$formatter.cloneVariable(this.$store.state.F_WH_ORDERS)
      this.filterObj = order.filter
    }
    this.$root.$on('listLoading', (data) => {
      this.orderObj.loading = data
    })
  },
  methods: {
    getOrderListHandler () {
      this.orderObj.loading = true
      this.filterObj.rowsperpage = this.pagination.itemsPerPage
      this.filterObj.descending = this.pagination.sortDesc[0]
      this.filterObj.sortby = this.pagination.sortBy[0]
      this.filterObj.page = this.pagination.page
      this.orderObj.module = this.MODULE_URL
      const getIds = this.$route.query.ids || null
      if (getIds) this.filterObj.ids = getIds ? JSON.parse(getIds) : []
      this.$_executeApi('post', `${this.MODULE_URL}/paginate_filter`, this.filterObj).then(response => {
        let orderList = response.data.items
        let transformList = { date: { list: ['orderdate'], from: 'DD.MM.YYYYTH:mm:ss', to: 'DD.MM.YYYY' },
          status: [{ list: ['type'], value: '$_orderType' }, { list: ['status'], value: '$_orderStatus' }, { list: ['priority'], value: '$_priorityList' }] }
        let model = this.$_formatListModel(orderList, transformList)
        let result = []
        model.forEach(element => {
          element.type_ref = element.type.value
          element.type = element.type.text
          element.status_ref = element.status.value
          element.status = element.status.text
          element.priority = element.priority.text
          result.push(element)
        })
        this.total = response.data.total
        if (this.filterObj.page > 1 && this.total <= this.filterObj.rowsperpage * (this.filterObj.page - 1)) {
          this.pagination.page = 1
          this.orderObj.page = 1
        }
        this.orderObj.list = result
      }).finally(() => {
        this.orderObj.loading = false
      })
    },
    navigateToOrder (item) {
      if (item.type_ref === CONSTANTS.SUPPLIER) return `/w_h/order/supplierorder/actions/${item.id}`
      else if (item.type_ref === CONSTANTS.ADJUSTMENT) return `/w_h/order/adjustmentorder/actions/${item.id}`
      else if (item.type_ref === CONSTANTS.RETURN) return `/w_h/order/returnorder/actions/${item.id}`
      else if (item.type_ref === CONSTANTS.TRANSFER) return `/w_h/order/transferorder/actions/${item.id}`
    },
    deleteOrder (item) {
      let payload = { ids: [item.id], url: `${this.MODULE_URL}/delete_multiple`, module: this.MODULE_URL }
      this.$store.commit('showDeleteDialog', payload)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
    this.$root.$on('listLoading')
  }
}
</script>
